import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Container, Row, Col, Image } from "react-bootstrap";
import { Check2, ArrowRight, LockFill, ClipboardData } from "react-bootstrap-icons";

import { useAuth } from "../contexts/AuthContext";

import CertificateDownloadButton from "./CertificateDownloadButton";
import ReceiptDownloadButton from "./ReceiptDownloadButton";

function Dashboard() {
  const { currentUser } = useAuth();
  const [sections, setSections] = useState([]);
  const [isEvaluationUnlocked, setIsEvaluationUnlocked] = useState(false);
  const [isEvaluationCompleted, setIsEvaluationCompleted] = useState(false);

  const getSectionIcon = (section) => {
    if (section.locked) {
      return <LockFill className="me-2 section-locked" />;
    } else if (section.completed) {
      return <Check2 className="me-2 section-complete" />;
    } else {
      return <ArrowRight className="me-2 section-in-progress" />;
    }
  };

  const getEvaluationIcon = () => {
    if (!isEvaluationUnlocked) {
      return <LockFill className="me-2 section-locked" />;
    } else if (isEvaluationCompleted) {
      return <Check2 className="me-2 section-complete" />;
    } else {
      return <ClipboardData className="me-2 text-primary" />;
    }
  };

  useEffect(() => {
    const API_URL = process.env.REACT_APP_API_URL || "http://localhost:3000";
    const retrieveSections = async () => {
      try {
        const response = await fetch(`${API_URL}/api/v1/sections`, {
          credentials: "include",
        });

        const data = await response.json();

        if (response.ok) {
          setSections(data.sections);
          setIsEvaluationUnlocked(data.evaluation_meta.unlocked);
          setIsEvaluationCompleted(data.evaluation_meta.completed);
        } else {
          console.error("Could not retrieve course modules data:", data);
        }
      } catch (error) {
        console.error("Error retrieving course modules data:", error);
      }
    };

    retrieveSections();
  }, []);

  return (
    <Container className="dashboard-purple flex-grow-1" fluid>
      <Container>
        <Row className="pt-5">
          <Col md={5} className="pr-5 pb-5">
            <Image
              src="/conversation.png"
              alt="Therapist Speaking with a Child"
              style={{ borderRadius: "5%" }}
              fluid
            />
          </Col>
          <Col md={7} className="pb-5">
            <div className="sections-header">
              Course Modules
            </div>
            <ul className="list-unstyled mt-4">
              {sections.map((section) => (
                <li className="sections-list" key={section.id}>
                  {section.locked ? (
                    <div
                      className="text-muted d-flex align-items-center"
                      style={{ cursor: "not-allowed" }}
                    >
                      {getSectionIcon(section)} {section.name}
                    </div>
                  ) : (
                    <Link
                      to={{ pathname: `/${section.slug}` }}
                      style={{ textDecoration: "none" }}
                      className="d-flex align-items-center"
                    >
                      {getSectionIcon(section)} {section.name}
                    </Link>
                  )}
                </li>
              ))}
            </ul>
            <hr className="my-4" style={{ borderColor: "rgba(0, 0, 0, 0.45)" }} />

            <div className="sections-list">
              {!isEvaluationUnlocked ? (
                <div
                  className="text-muted d-flex align-items-center"
                  style={{ cursor: "not-allowed" }}
                >
                  {getEvaluationIcon()} Course Evaluation
                </div>
              ) : (
                <Link
                  to="/evaluation"
                  style={{ textDecoration: "none" }}
                  className="d-flex align-items-center font-weight-bold"
                >
                  {getEvaluationIcon()} Course Evaluation
                </Link>
              )}
            </div>

          </Col>
        </Row>
      </Container>

      <div className="certificate-button">
        {isEvaluationCompleted && <CertificateDownloadButton />}
      </div>

    </Container>
  );
}

export default Dashboard;
